var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',{staticClass:"breadcrumb"},[_c('a-breadcrumb-item',[_vm._v("产业数字地图")]),_c('a-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta?.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }